import { render, staticRenderFns } from "./Syslist.vue?vue&type=template&id=21adbfbe&scoped=true&"
import script from "./Syslist.vue?vue&type=script&lang=js&"
export * from "./Syslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21adbfbe",
  null
  
)

export default component.exports